import { usePage } from "@inertiajs/react";
import { ChevronRightIcon } from "@heroicons/react/20/solid";

/**
 * BreadcrumbItem component
 * Renders a single breadcrumb item.
 *
 * @param {*} { item, isActive, isDisabled, isLast }
 * @returns
 */
function BreadcrumbItem({ item, isActive, isDisabled, isLast }) {
    return (
        <li className="flex items-center">
            <div
                className={`flex items-center relative justify-center text-white font-bold ${
                    item.current
                        ? "bg-[#4FA2DD] w-6 h-6"
                        : "bg-[#E7EEFA] w-3 h-3"
                } rounded-full`}
            >
                {item.current ? <span>{item.order}</span> : null}
                {item.current ? (
                    <span className="absolute -bottom-[24px] text-sm text-black">
                        {item.name}
                    </span>
                ) : null}
            </div>
            {!isLast && (
                <div className="h-[3px] w-9 lg:w-20 bg-[#E7EEFA]"></div>
            )}
        </li>
    );
}

/**
 * Breadcrumbs component
 * It uses the usePage hook to get the current page component
 * and then it filters the pages array to get the pages that
 * are before the current page
 *
 * @returns
 */
export default function Breadcrumbs() {
    const { component, props } = usePage();

    const pages = [
        {
            name: "TEST",
            href: route("skincare.index"),
            order: 1,
            component: "SkincareTest",
            current: false,
        },
        {
            name: "FORMULARIO",
            href: route("skincare.index"),
            order: 2,
            component: "SkincareForm",
            current: false,
        },
        // {
        //     name: "RESULTADOS",
        //     href: props.testResult
        //         ? route("skincare.show", { testResult: props.testResult.id })
        //         : "#",
        //     order: 3,
        //     component: "SkincareTestResult",
        //     current: false,
        // },
        {
            name: "TRATAMIENTO",
            href: props.testResult
                ? route("skincare.show", { testResult: props.testResult.id })
                : "#",
            order: 3,
            component: "SkincareTreatment",
            current: false,
        },
    ];

    const filteredPages = pages.map((page) => {
        if (page.component === component) {
            page.current = true;
        }

        return page;
    });

    return (
        <nav
            className="flex px-6 md:px-0 mb-4 lg:mb-6 lg:mt-4"
            aria-label="Breadcrumb"
        >
            <ol
                role="list"
                className="w-full flex flex-wrap flex-row items-center justify-center"
            >
                {filteredPages.map((page) => (
                    <BreadcrumbItem
                        key={page.name}
                        item={page}
                        isLast={page.order === pages.length}
                        isActive={page.component === component}
                        isDisabled={!page.href}
                    />
                ))}
            </ol>
        </nav>
    );
}
